import React from 'react';
import certificadosImg from '../../assets/images/patrocinados.png';
import '../navigation/styles/CertificacionBiomercy.css';
const CertificacionBiomercy = () => {
  return (
    <section className="certificados-section">
      <div className="certificados-logos">
        <img
          src={certificadosImg}
          loading="lazy"
          alt="Certificados de productos"
          className="certificados-img"
        />
      </div>
      <div className="pharma-white-line"></div>
    </section>
  );
};

export default CertificacionBiomercy;
